module.exports = __webpack_public_path__ + "img/feigua.be31ef27.png";